export default "__VITE_ASSET__CtUYEiEL__"